import { render, staticRenderFns } from "./WorkshopCreate.vue?vue&type=template&id=18aafacc"
import script from "./WorkshopCreate.vue?vue&type=script&lang=ts"
export * from "./WorkshopCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports